import { render, staticRenderFns } from "./NotificationsPage.vue?vue&type=template&id=7341193d&scoped=true&"
import script from "./NotificationsPage.vue?vue&type=script&lang=js&"
export * from "./NotificationsPage.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsPage.vue?vue&type=style&index=0&id=7341193d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7341193d",
  null
  
)

export default component.exports